/**
 * PO unit-price autofill rules: only Megaventory service SKUs, from ProductUnitCost.
 */

export function isPurchaseOrderServiceSku(detail: {
  service?: boolean | null;
  mv_product_type?: string | null;
}): boolean {
  if ((detail.mv_product_type ?? "").trim().toLowerCase() === "service") {
    return true;
  }
  return detail.service === true;
}

/**
 * Autofill PO unit price only for service SKUs, from Megaventory ProductUnitCost (`mv_unit_cost`).
 * Physical parts stay blank (quantity-sensitive buy prices).
 */
export function formatServiceSkuUnitPriceAutofill(detail: {
  service?: boolean | null;
  mv_product_type?: string | null;
  mv_unit_cost?: string | number | null;
}): string | null {
  if (!isPurchaseOrderServiceSku(detail)) {
    return null;
  }
  const raw = detail.mv_unit_cost;
  if (raw == null) {
    return null;
  }
  const cleaned = String(raw).trim().replace(/[$,\s]/g, "");
  if (cleaned === "") {
    return null;
  }
  const value = Number.parseFloat(cleaned);
  if (!Number.isFinite(value) || value < 0) {
    return null;
  }
  return (Math.round(value * 100) / 100).toFixed(2);
}
